<template>
    <div>
        <video-header>视频播放</video-header>
        <iframe :src="url" frameborder="0" width="100%"></iframe>
    </div>
    <!-- http://v.qq.com/iframe/player.html?vid=d0015bg8v6k&tiny=0&auto=0 -->
</template>

<script>
import videoHeader from '../../components/Header';
export default {
    name: 'video',
    components: {
        videoHeader
    },
    data() {
        return {
            url: ''
        }
    },
    mounted() {
        this.url = this.$route.query.realUrl
    },
}
</script>

<style scoped>
    
</style>